import type { TaskDetail } from '@frontend/api-types';
import type { CommonModalProps } from '@frontend/web-react';
import { Modal, YStack } from '@frontend/web-react';
import { TaskDetailSummaryTab } from '@frontend/web/components/DomainSpecific/Tasks/TaskDetailTab';

type TaskSummaryModalProps = CommonModalProps & {
  task?: TaskDetail;
};

export const TaskSummaryModal = ({ isOpen, onClose, task }: TaskSummaryModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <YStack className="w-full max-w-screen-lg">{task ? <TaskDetailSummaryTab task={task} /> : null}</YStack>
    </Modal>
  );
};
